var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1764_6164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1764_6164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.6667C7.07776 14.6667 6.21109 14.4917 5.39998 14.1417C4.58887 13.7917 3.88331 13.3167 3.28331 12.7167C2.68331 12.1167 2.20831 11.4111 1.85831 10.6C1.50831 9.78889 1.33331 8.92222 1.33331 8C1.33331 7.07778 1.50831 6.21111 1.85831 5.4C2.20831 4.58889 2.68331 3.88334 3.28331 3.28334C3.88331 2.68334 4.58887 2.20834 5.39998 1.85834C6.21109 1.50834 7.07776 1.33334 7.99998 1.33334C8.9222 1.33334 9.78887 1.50834 10.6 1.85834C11.4111 2.20834 12.1166 2.68334 12.7166 3.28334C13.3166 3.88334 13.7916 4.58889 14.1416 5.4C14.4916 6.21111 14.6666 7.07778 14.6666 8C14.6666 8.92222 14.4916 9.78889 14.1416 10.6C13.7916 11.4111 13.3166 12.1167 12.7166 12.7167C12.1166 13.3167 11.4111 13.7917 10.6 14.1417C9.78887 14.4917 8.9222 14.6667 7.99998 14.6667ZM4.21665 4.21667L7.99998 8V2.66667C7.28887 2.66667 6.60554 2.8 5.94998 3.06667C5.29442 3.33334 4.71665 3.71667 4.21665 4.21667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockLoader);
export default __webpack_public_path__ + "static/media/ClockLoader.d4b018412e5bf7f53a44c2c30983abe5.svg";
export { ForwardRef as ReactComponent };